export const customCTACenteredConfig = {
    name: 'CustomCTACentered',
    category: 'Zapier Sections',
    canHaveChildren: true,
    includeScrollTracking: true,
    inputs: [
        {
            name: 'heading',
            type: 'string',
            required: true,
        },
        {
            name: 'button',
            type: 'object',
            subFields: [
                {
                    name: 'variant',
                    type: 'string',
                    enum: ['primary', 'primary-alt', 'secondary'],
                    defaultValue: 'primary',
                },
                {
                    name: 'text',
                    type: 'string',
                },
                {
                    name: 'url',
                    friendlyName: 'URL',
                    type: 'string',
                },
            ],
        },
        {
            name: 'backgroundColor',
            type: 'string',
            enum: ['earth', 'moss', 'night', 'zapier'],
            defaultValue: 'earth',
        },
    ],
};
//# sourceMappingURL=config.js.map